import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  CustomerFeedbackSearchReqDTO,
  CustomerFeedbackSearchRes
} from 'src/models/review';
import { tourismClassifiedAPIRoutes } from '../tourism-classified';

export const reviewRatingService = createApi({
  reducerPath: 'reviewRatingServiceDetail',
  tagTypes: ['reviewRatingTag'],
  baseQuery: fetchBaseQuery({
    baseUrl: tourismClassifiedAPIRoutes.baseUrl,
    prepareHeaders: (headers) => {
      // If we have a token set in local storage, let's assume that we should be passing it.
      const token = localStorage.getItem('jwtToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: (builder) => ({
    getAllCustomerFeedback: builder.query({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.reviewRatingServiceDetail.endpoint}/${tourismClassifiedAPIRoutes.reviewRatingServiceDetail.getAllCustomerFeedback}/${body.page}/${body.offset}`,
        method: 'GET'
      }),
      providesTags: ['reviewRatingTag']
    }),

    getAllCustomerFeedbackMutation: builder.mutation({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.reviewRatingServiceDetail.endpoint}/${tourismClassifiedAPIRoutes.reviewRatingServiceDetail.getAllCustomerFeedback}/${body.page}/${body.offset}`,
        method: 'GET'
      }),
      invalidatesTags: ['reviewRatingTag']
    }),
    getAllFeedbackBySearchCriteria: builder.mutation<
      CustomerFeedbackSearchRes,
      CustomerFeedbackSearchReqDTO
    >({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.reviewRatingServiceDetail.endpoint}/${tourismClassifiedAPIRoutes.reviewRatingServiceDetail.getAllFeedbackBySearchCriteria}`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['reviewRatingTag']
    })
  })
});
export const {
  useGetAllCustomerFeedbackQuery,
  useGetAllCustomerFeedbackMutationMutation,
  useGetAllFeedbackBySearchCriteriaMutation
} = reviewRatingService;
